var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TYPED_STEP_ORDER = [
    'plan',
    'full-period',
    'pro-rata',
    'minimum',
    'discount',
    'extra',
    'old'
];
var STEP_CONTENT_BY_TYPE = {
    plan: {
        title: 'Base da conta',
        description: 'Tudo começa pela sua Mensalidade. Este é o valor fixo do seu plano contratado conosco para manter o seu acesso e serviços da plataforma ativos durante o mês.',
    },
    'full-period': {
        title: 'O que foi consumido',
        description: 'Aqui contabilizamos todos os tokens que começaram ativos no início do mês e se mantiveram até o dia do faturamento, e cobramos o valor cheio (equivalente à 30 dias de uso).',
    },
    'pro-rata': {
        title: 'Consumo pró-rata',
        description: 'Se uma assinatura foi ativada, cancelada, trocada ou suspensa após o início do mês (dia 2 em diante) e antes do dia do faturamento, ela aparece aqui, e cobramos apenas o valor proporcional aos dias consumidos. O mesmo vale para as que foram ativadas após o dia 16 do mês anterior.',
    },
    minimum: {
        title: 'A Garantia Mínima do Contrato',
        description: 'Se o seu contrato possui um compromisso mínimo de consumo (em quantidade de assinaturas ou valor) para determinados produtos e as suas vendas do mês não atingirem esse piso acordado, nós cobramos apenas a diferença exata que faltou para alcançar esse mínimo contratual.',
    },
    discount: {
        title: 'O ajuste proporcional (pró-rata)',
        description: 'Descontos aplicados proporcionalmente aos dias de uso parcial no período. Aparecem com sinal negativo.',
    },
    extra: {
        title: 'Outros ajustes',
        description: 'Qualquer situação fora do comum vai aparecer aqui. Pode ser resultado de uma negociação específica, uma cobrança extra avulsa ou um crédito bonificado concedido à sua conta.',
    },
    product: {
        title: 'Produtos contratados',
        description: 'Linhas referentes a cada produto contratado, com o cálculo individual de consumo e valor.',
    },
    'old': {
        title: 'Token mais minimo',
        description: 'Soma do valor total dos tokens consumidos com o minimo do plano contratado.',
    },
};
var TOTAL_STEP = {
    selector: '[data-tour="total-card"]',
    content: (_jsxs("div", { children: [_jsx("strong", { children: "Total a pagar" }), _jsx("p", __assign({ style: { marginTop: 8, marginBottom: 0 } }, { children: "Este \u00E9 o valor consolidado da sua fatura, somando a base do plano, consumo do per\u00EDodo e quaisquer ajustes aplicados." }))] })),
};
function shouldIncludeStep(type, items) {
    if (type === 'full-period') {
        return items.some(function (item) { return item.full_period !== null && item.full_period !== undefined; });
    }
    if (type === 'pro-rata') {
        return items.some(function (item) { return item.partial_period !== null && item.partial_period !== undefined; });
    }
    return items.some(function (item) {
        return item.type === type &&
            item.total !== null &&
            item.total !== undefined;
    });
}
export function buildTourSteps(items) {
    var steps = [TOTAL_STEP];
    for (var _i = 0, TYPED_STEP_ORDER_1 = TYPED_STEP_ORDER; _i < TYPED_STEP_ORDER_1.length; _i++) {
        var type = TYPED_STEP_ORDER_1[_i];
        if (!shouldIncludeStep(type, items))
            continue;
        var copy = STEP_CONTENT_BY_TYPE[type];
        if (!copy)
            continue;
        var selector = "[data-tour=\"group-".concat(type, "\"]");
        if (type === 'pro-rata') {
            selector = '[data-tour="col-pro-rata"]';
        }
        else if (type === 'full-period') {
            selector = '[data-tour="col-full-period"]';
        }
        steps.push({
            selector: selector,
            content: (_jsxs("div", { children: [_jsx("strong", { children: copy.title }), _jsx("p", __assign({ style: { marginTop: 8, marginBottom: 0 } }, { children: copy.description }))] })),
        });
    }
    return steps;
}
